import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
    { label: 'Features', path: '#features' },
    { label: 'Pricing', path: '#pricing' },
    { label: 'Security', path: '#security' },
    { label: 'Integrations', path: '#integrations' }],

    company: [
    { label: 'About Us', path: '#about' },
    { label: 'Careers', path: '#careers' },
    { label: 'Blog', path: '#blog' },
    { label: 'Press Kit', path: '#press' }],

    resources: [
    { label: 'Documentation', path: '#docs' },
    { label: 'Help Center', path: '#help' },
    { label: 'API Reference', path: '#api' },
    { label: 'Community', path: '#community' }],

    legal: [
    { label: 'Privacy Policy', path: '#privacy' },
    { label: 'Terms of Service', path: '#terms' },
    { label: 'Cookie Policy', path: '#cookies' },
    { label: 'GDPR', path: '#gdpr' }]

  };

  const socialLinks = [
  { icon: 'Linkedin', url: '#linkedin', label: 'LinkedIn' },
  { icon: 'Twitter', url: '#twitter', label: 'Twitter' },
  { icon: 'Github', url: '#github', label: 'GitHub' },
  { icon: 'Mail', url: '#email', label: 'Email' }];


  return (
    <footer className="bg-secondary border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-5 gap-8 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Image
                src="https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763809516/First_on_Date_Logo_paokx0.png"
                alt="Bee Wise company logo featuring yellow bee icon representing employee onboarding platform"
                className="h-10 w-auto" />

            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Transform chaotic onboarding into structured success with AI-powered assistance
            </p>
            <div className="flex gap-3">
              {socialLinks?.map((social, index) =>
              <a
                key={index}
                href={social?.url}
                aria-label={social?.label}
                className="w-9 h-9 bg-muted/50 hover:bg-muted rounded-lg flex items-center justify-center transition-colors duration-150">

                  <Icon name={social?.icon} size={18} color="var(--color-muted-foreground)" />
                </a>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Product</h4>
            <ul className="space-y-2">
              {footerLinks?.product?.map((link, index) =>
              <li key={index}>
                  <a
                  href={link?.path}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">

                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks?.company?.map((link, index) =>
              <li key={index}>
                  <a
                  href={link?.path}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">

                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-2">
              {footerLinks?.resources?.map((link, index) =>
              <li key={index}>
                  <a
                  href={link?.path}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">

                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-2">
              {footerLinks?.legal?.map((link, index) =>
              <li key={index}>
                  <a
                  href={link?.path}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">

                    {link?.label}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Bee Wise. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-muted-foreground">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={14} color="var(--color-success)" />
                <span>SOC 2 Certified</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={14} color="var(--color-success)" />
                <span>GDPR Compliant</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Award" size={14} color="var(--color-success)" />
                <span>ISO 27001</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;